import { __zcAsy, __zcFin, __zcIT, __zcITc, __zcMkv, __zcPs, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {FormFieldValidationSchema} from './formFieldValidation'

export const FormFieldSelectSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('formFieldSelect', {
  fields: z.lazy(() =>
    z.object({
      htmlName: z.string(),
      label: z.string(),
      options: z.looseObject({}).catchall(z.string()),
      validations: safeOptional(z.array(FormFieldValidationSchema)),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["validations"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __rfz_0=__rf[0]._zod;
var __rfn_20=__rf[1];
function safeParse_FormFieldSelectSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["htmlName"];if(typeof __sv_11!=="string"){_e.push(__zcIT("string",__sv_11,["fields","htmlName"]));}
var __sv_12=__sv_9["label"];if(typeof __sv_12!=="string"){_e.push(__zcIT("string",__sv_12,["fields","label"]));}
var __sv_13=__sv_9["options"];if(typeof __sv_13!=="object"||__sv_13===null||Array.isArray(__sv_13)){_e.push(__zcIT("object",__sv_13,["fields","options"]));}else{var __o_14=__sv_13;__o_14=__zcPs(__o_14);for(var __ck_15 in __sv_13){if(!(false)&&__ck_15!=="__proto__"){var __cv_16=__sv_13[__ck_15];var __co_17=__cv_16;if(typeof __cv_16!=="string"){_e.push(__zcIT("string",__cv_16,["fields","options",__ck_15]));}
if(__co_17!==__cv_16){if(__o_14===__sv_13){__o_14={...__sv_13};}__o_14[__ck_15]=__co_17;}}}__sv_13=__o_14;}
var __sv_18=__sv_9["validations"];if(__sv_18!==undefined){var __ib_19=_e.length;if(_e.length===__ib_19){__sv_18=__rfn_20(__sv_18);if(__sv_18 instanceof Promise)__zcAsy();}
}
var __o_10={"htmlName":__sv_11,"label":__sv_12,"options":__sv_13};if(__sv_18!==undefined||("validations" in __sv_9)){__o_10["validations"]=__sv_18;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_FormFieldSelectSchema,__zs,null,null);
})()

export type FormFieldSelect = z.infer<typeof FormFieldSelectSchema>

export const isFormFieldSelect = (value: unknown): value is FormFieldSelect => {
  return FormFieldSelectSchema.safeParse(value).success
}
